<h1 i18n="users|Page title">Users</h1>

<app-paginated-table
  #usersTable
  [columns]="columns"
  [filters]="filters"
  [query]="usersGQL"
  [dataMapper]="dataMapper"
  [groupRowsBy]="'account.company'"
  (rowClick)="onUserClick($event)"
  (selectionChange)="onSelectionChange($event)"
  (selectAllChange)="onSelectAllChange($event)"
  (filterQueryParameterChange)="onFilterQueryParameterChange($event)"
  [rowMenuItems]="rowMenuItems">
</app-paginated-table>

<p-toolbar>
  <ng-template #start>
    <p-button icon="pi pi-download" label="Export" (click)="onExportClick()" i18n="users|Export button"></p-button>
    <p-button icon="pi pi-user-plus" label="Create user" (click)="onCreateUserClick()" i18n="users|Create new user button"></p-button>
  </ng-template>
</p-toolbar>
